import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTopListener({ history }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    });
    return () => {
      unlisten();
    }
  }, []);

  return (null);
}

export default withRouter(ScrollToTopListener);

export const scrollToTop  = () => {
  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
}


// WEBPACK FOOTER //
// ./src/utils/scrollToTop.jsx